export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '0.6308.638',
    name: 'orga-app-desktop-client',
    versionDate: '2026-11-04T10:40:40.264Z',
    description: 'ORGArena ORGA App',
    gitCommitHash: 'g0ddfbcea',
    gitCommitDate: '2026-11-04T10:35:07.000Z',
    versionLong: '0.6308.638-g0ddfbcea',
    gitTag: 'v1.55.4',
};
export default versions;
